// extracted by mini-css-extract-plugin
export default {"modalContent":"style_modalContent__OBruC","title":"style_title__9n93+","description":"style_description__nzzCx","actionIcon":"style_actionIcon__cQafl"};